import { render, staticRenderFns } from "./VideoCreator.vue?vue&type=template&id=4b30437e&scoped=true"
import script from "./VideoCreator.vue?vue&type=script&lang=js"
export * from "./VideoCreator.vue?vue&type=script&lang=js"
import style0 from "./VideoCreator.vue?vue&type=style&index=0&id=4b30437e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b30437e",
  null
  
)

export default component.exports